import React from 'react'
import { Link } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TableVirtuoso  } from 'react-virtuoso';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { Box, Drawer, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { getEventsMasterMappingData } from '../../../api/mappingApi';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';

const columns = [
    { id: 'EId', label: 'Event ID',width:130},
    { id: 'EnglishText', label: 'Event Name', width:350},
    { id: 'Config', label: 'Configurations',width:250},
    { id: 'MasterMapping', label: 'Master Config',width:150},
    { id: 'Actions', label: 'Actions',width:190}
];

const subColumns = [
    { id: 'EId', label: 'Event ID'},
    { id: 'ETxt', label: 'English Text'},
    { id: 'FTxt', label: 'French Text'},
    { id: 'STxt', label: 'Spanish Text'},
    { id: 'GTxt', label: 'German Text'},
    { id: 'ITxt', label: 'Italian Text'},
    { id: 'DTxt', label: 'Dutch Text'},
    { id: 'NTxt', label: 'Norwegian Text'},
    { id: 'PTxt', label: 'Polish Text'},
    { id: 'PeTxt', label: 'Portuguese Text'},
    { id: 'TTxt', label: 'Turkish Text'},
    { id: 'CTxt', label: 'Chinese Text'},
    { id: 'RTxt', label: 'Russian Text'},
    { id: 'SigAddr', label: 'Signal'},
    { id: 'Spn', label: 'SPN'},
    { id: 'Fmi', label: 'FMI'},
    { id: 'Divider', label: 'Divider'},
    { id: 'RDef', label: 'Relation Def'},
    { id: 'EType', label: 'Event Type'},
    { id: 'AR', label: 'AutoReset'},
    { id: 'TOn', label: 'Time On'},
    { id: 'LOn', label: 'Level On'},
    { id: 'LOS', label: 'Level On Scaler'},
    { id: 'TOff', label: 'Time Off'},
    { id: 'ECNTRSig', label: 'Event Counter Reset Signal'},
    { id: 'ECNTRDel', label: 'Event Counter Reset Delay'},
    { id: 'ARTFactor', label: 'Auto Reset Time Factor' },
    { id: 'IB1', label: 'Inhibit1'},
    { id: 'IBT1', label: 'Inhibit Time1'},
    { id: 'IB2', label: 'Inhibit2' },
    { id: 'IBT2', label: 'Inhibit Time2'},
    { id: 'Sig0', label: 'Log Signal0' },
    { id: 'Sig1', label: 'Log Signal1'},
    { id: 'Sig2', label: 'Log Signal2'},
    { id: 'Sig3', label: 'Log Signal3'},
    { id: 'Sig4', label: 'Log Signal4'},
    { id: 'Sig5', label: 'Log Signal5'},
    { id: 'Sig6', label: 'Log Signal6'},
    { id: 'Sig7', label: 'Log Signal7'},
    { id: 'En', label: 'Enable'},
    { id: 'HE', label: 'Horn Event'},
    { id: 'RSA3B', label: 'RSA3Bit' },
    { id: 'Family', label: 'Family'},
    { id: 'TTID', label: 'Tool Tip ID'},
];

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});


const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align={column.numeric || false ? 'right' : 'left'}
            style={{ width: column.width }}
            sx={{
              backgroundColor: 'background.paper',
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
}

const MappingEventTable = ({data,handleRowDelete,setShowLoader}) => {

    const [open, setOpen] = React.useState(false);
    const [tableData, setTableData] = React.useState(false);
    const [modalType, setModalType] = React.useState('');
    const [jsonRowData, setJsonRowData] = React.useState('');
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const tableHeight = data?.length === 1 ? 240 : data?.length === 2  ? 420 : 600;
    const handleClickOpen = async (rowData,type) => {
        setOpen(true);
        setModalType(type);
        setShowLoader(true);
        const materMappingData = await getEventsMasterMappingData(rowData.EId);
        setShowLoader(false);
        setTableData(materMappingData);
    };

    const handleClose = () => {
        setOpen(false);
        setModalType('')
        setJsonRowData('')
    };

    const handleDrawer = (rowData) => {
        setOpenDrawer(true);
        setJsonRowData(rowData);
    }

    const Row = ({index}) => {
        const row = data[index];
        const {EnglishText,...otherKeys} = row;
        const rowData =  JSON.stringify(otherKeys,null,2);
        let trimJsonData;
        if(rowData.length <= 50) {
            trimJsonData = rowData;
        } else {
            trimJsonData = rowData.substring(0,50) + ' ...';
        }
        return (
            <>
                {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                                ? column.format(value)
                                :  column.id === 'MasterMapping' ?
                                    <IconButton
                                    color="inherit"
                                    title="Master Mapping List"
                                    onClick={() => handleClickOpen(row,'mapping')}
                                    >
                                        <InfoRoundedIcon />
                                    </IconButton>
                                :  column.id === 'Actions' ?
                                    <>
                                        <IconButton
                                            color="inherit"
                                            style={{ backgroundColor: 'transparent' }}
                                            title="View Full Configurations"
                                            onClick={() => handleDrawer(rowData)}
                                        >
                                            <OpenInFullRoundedIcon />
                                        </IconButton>
                                        <IconButton
                                            color="inherit"
                                            title="Edit Data"
                                            component={Link} 
                                            to="/mapping/events/edit"
                                            state={{ eventId : row.EId}}
                                        >
                                            <EditRoundedIcon />
                                        </IconButton>
                                        <IconButton
                                            color="error"
                                            title="Delete Row"
                                            onClick={() => handleRowDelete(index)}
                                        >
                                            <DeleteRoundedIcon />
                                        </IconButton>
                                    </>
                                    : column.id === 'Config' ? 

                                    <pre style={{whiteSpace:'pre-wrap',wordWrap:'break-word',fontFamily:'Roboto,sans-serif',lineHeight:'18px',fontSize:'13px'}}>
                                        {trimJsonData}
                                    </pre>
                                : value
                            }
                        </TableCell>
                    );
                })}
            </>
        )
    }

    return (
        <>
            { data?.length > 0 &&
                <Paper style={{ height:tableHeight, width: '100%' }}>            
                    <TableVirtuoso 
                        className='TableVirtuoso'
                        totalCount={data?.length}
                        data={data}
                        components={VirtuosoTableComponents}
                        fixedHeaderContent={fixedHeaderContent}
                        itemContent={(index) => (<Row index={index} />)}
                        useWindowScroll={false}
                    />   
                </Paper> 
            }
            <Dialog
                closeAfterTransition={false}
                fullWidth={modalType === 'mapping' ? false : true}
                maxWidth={modalType === 'mapping' ? 'sm' : 'md'}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>{modalType === 'mapping' ? 'Master Mapping List' : 'Configurations'}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon />
                </IconButton>
                <DialogContent dividers>
                    {modalType === 'mapping' &&
                        <Table>
                            <TableBody>
                                <Box className="collapseTable" sx={{ height:"300px",marginTop: 2, marginBottom:2 }}>
                                    <PerfectScrollbar>
                                        { Object.keys(tableData).map((keyIndex) => {
                                            const label = subColumns.map(col => keyIndex === col.id ? col.label : '' )
                                            return (
                                                <TableRow>
                                                    <TableCell><strong>{label}</strong></TableCell>
                                                    <TableCell>{tableData[keyIndex]}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </PerfectScrollbar>
                                </Box>    
                            </TableBody>
                        </Table>
                    }

                    {modalType === 'config' &&
                    <TextField 
                        className='jsonTextArea'
                        value={jsonRowData}
                        InputProps={{
                            rows: 10,
                            multiline: true,
                            inputComponent: 'textarea',
                        }} 
                    />            
                    }

                </DialogContent>
            </Dialog>
            <Drawer
                open={openDrawer}
                anchor={"right"}
                onClose={() => setOpenDrawer(false)}
            >
                
                <Box sx={{p:2,width:{ md: 500, xs:250 }}} >
                    <pre style={{whiteSpace:'pre-wrap',wordWrap:'break-word',fontFamily:'Roboto,sans-serif',lineHeight:'30px'}}>
                        {jsonRowData}
                    </pre>
                </Box>
            </Drawer>
        </>
    )
}

export default MappingEventTable